import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { isRelation } from '../decorators/relation.decorator';

@Injectable({
  providedIn: 'root'
})
export class PreviewApiService {
  private http = inject(HttpClient);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  upsertPreview(type: 'exercise' | 'exam' | 'explanation', id: string, data: unknown): Observable<any> {
    const cleanData = this.toPlainData(data);
    return this.http.put(`${environment.apiUrl}/${type}/preview/${id}`, cleanData);
  }

  /**
   * Converts entity data to a plain object, stripping relation fields and DatX metadata.
   *
   * DatX models (e.g. ExplanationJsonModel) are detected generically via their __META__ property
   * instead of importing from @datx/core, because DatX is deprecated in this project.
   * Once ExplanationComponent is migrated to NGXS (ExplanationEntity), the __META__ checks
   * can be removed entirely – only the isRelation() branch will remain.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private toPlainData(entity: any): Record<string, unknown> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result: Record<string, any> = {};

    for (const key of Object.keys(entity)) {
      // Skip DatX internal metadata (deprecated ExplanationJsonModel)
      if (key === '__META__') {
        continue;
      }
      // Skip @Relation() decorated fields (NGXS entities: Exercise, Exam)
      if (isRelation(entity, key)) {
        continue;
      }
      // Skip DatX toMany relation fields (arrays of DatX models containing __META__)
      if (Array.isArray(entity[key]) && entity[key].length > 0 && entity[key][0]?.__META__) {
        continue;
      }
      // Skip DatX toOne relation fields (single DatX model containing __META__)
      if (entity[key] && typeof entity[key] === 'object' && !Array.isArray(entity[key]) && entity[key].__META__) {
        continue;
      }
      result[key] = entity[key];
    }

    return result;
  }
}
